import { useCallback } from 'react';

import api from 'shared/utils/api';
import useMergeState from 'shared/hooks/mergeState';

type PropT={
  [x:string] : string
}


const useMutation = (method: string, url?: string) => {
  const [state, mergeState] = useMergeState({
    data: null,
    error: null,
    isWorking: false,
  }); 
 
  const makeRequest = useCallback(
    (variables = {}) =>
      new Promise((resolve, reject) => {
        mergeState({ isWorking: true });

        api[method](url, variables).then(
          (data:any) => {
            resolve(data);
            mergeState({ data, error: null, isWorking: false });
          },
          (error:any) => {
            reject(error);
            mergeState({ error, data: null, isWorking: false });
          },
        );
      }),
    [method, url, mergeState],
  );

  return [
    {
      ...state,
      [isWorkingAlias[method]]: state.isWorking,
    },
    makeRequest,
  ];
};

const isWorkingAlias : PropT = {
  post: 'isCreating',
  put: 'isUpdating',
  patch: 'isUpdating',
  delete: 'isDeleting',
};

export default useMutation;
